import { render, staticRenderFns } from "./AutorizarTraspaso.vue?vue&type=template&id=31b67724&scoped=true"
import script from "./AutorizarTraspaso.vue?vue&type=script&lang=js"
export * from "./AutorizarTraspaso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b67724",
  null
  
)

export default component.exports